import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMessages } from 'store/chat/services/getMessages.service';
import { uniq } from 'lodash';
import { loadChatUsers } from './loadChatUsers';

export const fetchChatMessagesThunk = createAsyncThunk(
  'chat/fetchMessages',
  async ({ limit, refresh = false }, { getState, dispatch }) => {
    const state = getState();
    const { allMessagesFetched, thread, lastEvaluatedKey } = state.chatSlice;
    // A refresh (initial open / revalidating a cached thread) always reads the newest
    // page from the top; regular scroll paging continues from the saved cursor and
    // stops once everything older has been fetched.
    if (refresh || !allMessagesFetched) {
      const threadId = thread.isSubthread
        ? 'subthread'
        : thread.threadId || thread.id;
      const messages = await getMessages(
        threadId,
        refresh ? null : lastEvaluatedKey,
        limit,
        thread.target,
        thread.type
      );
      const messageSenderIds = uniq(messages.map((msg) => msg.userId));
      // Filter out users that are already in users OR allUsers
      const newUserIds = messageSenderIds.filter(
        (id) => !state.chatSlice.users[id] && !state.chatSlice.allUsers[id]
      );
      if (newUserIds.length > 0) {
        dispatch(
          loadChatUsers({ userIds: newUserIds, addToCurrentUsers: true })
        );
      }
      return { messages, refresh };
    }
    return { messages: [], refresh };
  }
);
